(function () {
  const FINTOC_ICON =
    '<img src="/cdn/shop/files/wf-dfe9da1e072f.png?v=1788311231&width=64" alt="" width="28" height="7" style="max-height:18px;width:auto">';

  function buildDualContent(title, subtitle, iconHtml) {
    return (
      '<span class="payment-btn__layout">' +
      '<span class="payment-btn__icon">' +
      iconHtml +
      '</span>' +
      '<span class="payment-btn__copy">' +
      '<strong class="payment-btn__title">' +
      title +
      '</strong>' +
      '<span class="payment-btn__subtitle">' +
      subtitle +
      '</span>' +
      '</span>' +
      '</span>'
    );
  }

  function ensureShadowStyles(shadowRoot) {
    if (!shadowRoot || shadowRoot.querySelector('#payment-btn-styles')) return;

    const style = document.createElement('style');
    style.id = 'payment-btn-styles';
    style.textContent =
      'button.payment-btn-dual{display:flex!important;align-items:center!important;justify-content:flex-start!important;text-align:left!important;width:100%!important;min-height:72px!important;height:auto!important;padding:14px 18px!important;background:#fff!important;border:none!important;border-radius:14px!important}' +
      '.payment-btn__layout{display:flex;align-items:center;gap:14px;width:100%}' +
      '.payment-btn__icon{display:flex;align-items:center;justify-content:center;flex-shrink:0;min-width:28px}' +
      '.payment-btn__icon img{max-height:18px;width:auto}' +
      '.payment-btn__copy{display:flex;flex-direction:column;gap:2px;min-width:0}' +
      '.payment-btn__title{display:block;font-size:15px;font-weight:700;line-height:1.25;color:#000!important}' +
      '.payment-btn__subtitle{display:block;font-size:12px;font-weight:400;line-height:1.3;color:#666!important}';
    shadowRoot.appendChild(style);
  }

  function enhanceFintocButton(button) {
    if (!button || button.querySelector('.payment-btn__title')) return;

    ensureShadowStyles(button.getRootNode());

    const icon =
      button.querySelector('img')?.outerHTML ||
      button.querySelector('[part="icon"]')?.innerHTML ||
      FINTOC_ICON;

    button.dataset.paymentEnhanced = 'fintoc';
    button.classList.add('payment-btn-dual', 'payment-btn-dual--fintoc');
    button.innerHTML = buildDualContent(
      'Pagar con FINTOC y obtener 5% de descuento',
      'Sin tarjeta • Pago bancario con Fintoc',
      icon
    );
  }

  function findFintocButton() {
    const hosts = document.querySelectorAll('scala-cart-button');
    for (const scalaHost of hosts) {
      if (scalaHost.closest('product-form-component, .product-form-buttons, .buy-buttons-block')) {
        continue;
      }
      if (scalaHost.shadowRoot) {
        return (
          scalaHost.shadowRoot.querySelector('#scala-button') ||
          scalaHost.shadowRoot.querySelector('button[data-trigger]') ||
          scalaHost.shadowRoot.querySelector('button')
        );
      }
    }
    return null;
  }

  function forceAddToCartBlack() {
    document
      .querySelectorAll(
        '.product-form-buttons button.add-to-cart-button, button.sticky-add-to-cart__button'
      )
      .forEach((btn) => {
        btn.style.setProperty('color', '#000000', 'important');
        btn.style.setProperty('-webkit-text-fill-color', '#000000', 'important');
        btn.querySelectorAll('span, svg, path').forEach((el) => {
          if (el.closest('.add-to-cart__added')) return;
          el.style.setProperty('color', '#000000', 'important');
          el.style.setProperty('-webkit-text-fill-color', '#000000', 'important');
          if (el.tagName === 'svg' || el.tagName === 'path') {
            el.style.setProperty('stroke', '#000000', 'important');
          }
        });
      });
  }

  function formularioCarrito() {
    return (
      document.getElementById('cart-form') ||
      document.querySelector('form#cart-form') ||
      document.querySelector('cart-items-component form') ||
      document.querySelector('form[action="/cart"]') ||
      document.querySelector('form[action*="/cart"]')
    );
  }

  function enviarCheckoutFlow() {
    const form = formularioCarrito();
    if (!form) {
      window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
      return;
    }

    let input = form.querySelector('input[name="checkout"][data-flow-force]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '';
      input.setAttribute('data-flow-force', '1');
      form.appendChild(input);
    }
    form.submit();
  }

  /*
    Flow ya no usa name="checkout", asi Scala no se le pega encima.
    Este handler es el unico camino a checkout con tarjeta.
  */
  var flowClickListo = false;
  function instalarClickFlow() {
    if (flowClickListo) return;
    flowClickListo = true;

    function onFlowTap(event) {
      const btn = event.target.closest && event.target.closest('[data-checkout-flow]');
      if (!btn || btn.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      enviarCheckoutFlow();
    }

    document.addEventListener('click', onFlowTap, true);
    document.addEventListener('touchend', onFlowTap, true);
  }

  function separarBotonesCarrito() {
    const roots = [
      ...document.querySelectorAll('.cart-drawer, cart-drawer-component'),
      ...document.querySelectorAll('main .cart__ctas, .cart-summary .cart__ctas, cart-items-component .cart__ctas'),
    ];
    const seen = new Set();

    roots.forEach((root) => {
      const ctas =
        root.classList?.contains('cart__ctas') ? root : root.querySelector('.cart__ctas');
      if (!ctas || seen.has(ctas)) return;
      seen.add(ctas);

      const drawer = ctas.closest('.cart-drawer, cart-drawer-component, cart-items-component') || root;
      const flow = ctas.querySelector('[data-checkout-flow]');
      const anchor = ctas.querySelector('.cart__checkout-scala-anchor, button#checkout[name="checkout"]');
      const scala =
        ctas.querySelector('scala-cart-button') ||
        drawer.querySelector?.('.cart-drawer__summary scala-cart-button') ||
        drawer.querySelector?.('scala-cart-button');

      if (flow) {
        flow.style.setProperty('position', 'relative', 'important');
        flow.style.setProperty('z-index', '50', 'important');
        flow.style.setProperty('pointer-events', 'auto', 'important');
        flow.style.setProperty('order', '1', 'important');
      }

      if (anchor) {
        anchor.style.setProperty('order', '2', 'important');
        anchor.style.setProperty('pointer-events', 'none', 'important');
        anchor.style.setProperty('height', '0', 'important');
        anchor.style.setProperty('min-height', '0', 'important');
        anchor.style.setProperty('max-height', '0', 'important');
        anchor.style.setProperty('opacity', '1', 'important');
        anchor.style.setProperty('overflow', 'hidden', 'important');
        anchor.removeAttribute('aria-hidden');
      }

      if (scala) {
        // Fintoc SIEMPRE despues del ancla, nunca encima de Flow
        if (anchor) {
          if (scala.previousElementSibling !== anchor) {
            anchor.insertAdjacentElement('afterend', scala);
          }
        } else if (scala.parentElement !== ctas) {
          ctas.appendChild(scala);
        }

        // Scala oculta el boton (display:none) si el ancla name=checkout
        // esta clip/opacity:0. Forzar visible en el drawer.
        scala.style.setProperty('display', 'block', 'important');
        scala.style.setProperty('visibility', 'visible', 'important');
        scala.style.setProperty('opacity', '1', 'important');
        scala.style.setProperty('height', 'auto', 'important');
        scala.style.setProperty('min-height', '72px', 'important');
        scala.style.setProperty('max-height', 'none', 'important');
        scala.style.setProperty('overflow', 'visible', 'important');
        scala.style.setProperty('position', 'relative', 'important');
        scala.style.setProperty('top', 'auto', 'important');
        scala.style.setProperty('left', 'auto', 'important');
        scala.style.setProperty('right', 'auto', 'important');
        scala.style.setProperty('bottom', 'auto', 'important');
        scala.style.setProperty('inset', 'auto', 'important');
        scala.style.setProperty('transform', 'none', 'important');
        scala.style.setProperty('z-index', '1', 'important');
        scala.style.setProperty('order', '3', 'important');
        scala.style.setProperty('width', '100%', 'important');
        scala.style.setProperty('margin', '0', 'important');
        scala.style.setProperty('pointer-events', 'auto', 'important');
        scala.removeAttribute('hidden');
        scala.removeAttribute('aria-hidden');
      }

      drawer.querySelectorAll?.('.tpo-btn-wrapper, .tpo-buy-it-now-btn').forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  }

  function initPaymentButtons() {
    forceAddToCartBlack();
    separarBotonesCarrito();
    instalarClickFlow();

    const fintocButton = findFintocButton();
    if (fintocButton) enhanceFintocButton(fintocButton);
  }

  document.addEventListener('DOMContentLoaded', initPaymentButtons);

  var timer;
  const observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(initPaymentButtons, 100);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  [300, 800, 1500, 2500, 4000].forEach((ms) => {
    setTimeout(initPaymentButtons, ms);
  });
})();
